module.exports = __webpack_public_path__ + "static/media/organization-vector.09ca37b7.svg";